import * as actions from '@/constants/actions';
import * as mutations from '@/constants/mutations';

export default {
    state: {
        // specifically track if source data is loaded
        // used for showing a separate loading indicator
        sourceDataLoaded: false,
        // viewport extent in minX, minY, maxX, maxY order
        bbox: [],
        // map center coordinates with lng, lat
        center: {},

        // selected map features
        selectedWatershed: null,
        selectedStation: null,
        selectedLicence: null,

        // map legend
        showMapLegend: true,
    },
    mutations: {
        [mutations.SET_MAP_BOUNDS](state, bbox) {
            state.bbox = bbox;
        },
        [mutations.SET_SELECTED_WATERSHED](state, watershed) {
            state.selectedWatershed = watershed;
        },
        [mutations.SET_SELECTED_STATION](state, station) {
            state.selectedStation = station;
        },
        [mutations.SET_SELECTED_LICENCE](state, licence) {
            state.selectedLicence = licence;
        },
        [mutations.SET_MAP_CENTER](state, centerCoords) {
            state.center = centerCoords;
        },
        [mutations.SET_MAP_SOURCE_DATA_LOADED](state, loaded) {
            state.sourceDataLoaded = loaded;
        },
        [mutations.SHOW_MAP_LEGEND](state, loaded) {
            state.showMapLegend = loaded;
        },
    },
    actions: {
        [actions.SET_MAP_BOUNDS]({ commit }, bbox) {
            commit(mutations.SET_MAP_BOUNDS, bbox);
        },
        /**
         * select a station feature on the map,
         * and switch sidebar context
         * @param  {Object} station object with id & coords[]
         */
        [actions.SELECT_STATION]({ commit }, station) {
            // change the sidebar context
            if (station) {
                commit(mutations.SET_SIDEBAR_CONTEXT, 'station');
            } else {
                commit(mutations.SET_SIDEBAR_CONTEXT, 'live');
            }
            // set the id
            commit(mutations.SET_SELECTED_STATION, station);
        },
        /**
         * select a licence feature on the map,
         * and switch sidebar context
         * @param  {Object} licence object with id & coords[]
         */
        [actions.SELECT_LICENCE]({ commit }, licence) {
            // change the sidebar context
            if (licence) {
                commit(mutations.SET_SIDEBAR_CONTEXT, 'licence');
            } else {
                commit(mutations.SET_SIDEBAR_CONTEXT, 'live');
            }
            // set the id
            commit(mutations.SET_SELECTED_LICENCE, licence);
        },
        /**
         * select a watershed and switch sidebar context
         */
        [actions.SELECT_WATERSHED]({ commit }, watershed) {
            // set the id
            commit(mutations.SET_SELECTED_WATERSHED, watershed);
            // change the sidebar context
            if (watershed) {
                commit(mutations.SET_SIDEBAR_CONTEXT, 'watershed');
            } else {
                commit(mutations.SET_SIDEBAR_CONTEXT, 'live');
            }
        },
        [actions.SET_MAP_CENTER]({ commit }, centerCoords) {
            commit(mutations.SET_MAP_CENTER, centerCoords);
        },
        [actions.SET_MAP_SOURCE_DATA_LOADED]({ commit }, loaded = true) {
            commit(mutations.SET_MAP_SOURCE_DATA_LOADED, loaded);
        },
        [actions.SHOW_MAP_LEGEND]({ commit }, show) {
            commit(mutations.SHOW_MAP_LEGEND, show);
        },
    },
};



// WEBPACK FOOTER //
// ./src/store/modules/MapModule.js